import { render, staticRenderFns } from "./RestoreExpenses.vue?vue&type=template&id=effcbf44&scoped=true"
import script from "./RestoreExpenses.vue?vue&type=script&lang=js"
export * from "./RestoreExpenses.vue?vue&type=script&lang=js"
import style0 from "./RestoreExpenses.vue?vue&type=style&index=0&id=effcbf44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "effcbf44",
  null
  
)

export default component.exports